import React, { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import CreateNewProjectButton from 'containers/Mail/Projects/CreateNewProjectButton';
import ProjectEditorModal from 'containers/Mail/Projects/ProjectEditorModal';
import { Col, Row, Select, SelectOption } from 'components/ui';
import { getProjects } from 'store/selectors/projects';
import { addProject } from 'store/actions/projects';

const ProjectField = ({ title }) => {
  const { control } = useFormContext();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const projects = useSelector(getProjects);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleAddNewProject = newProject => {
    dispatch(addProject(newProject));
    handleCloseModal();
  };

  return (
    <>
      <section className="send-mail-form__section">
        <h5>{title} *</h5>
        <Row gutter={8}>
          <Col span={15}>
            <Controller
              control={control}
              name="projectId"
              render={({ field, fieldState }) => {
                return (
                  <Select
                    error={!!fieldState.error}
                    helperTxt={fieldState.error?.message}
                    name="projectId"
                    optionFilterProp="children"
                    showSearch
                    value={field.value}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                  >
                    <SelectOption key="default" value={-1}>
                      Select {title}
                    </SelectOption>
                    {projects.map(project => (
                      <SelectOption key={project.id} value={project.id}>
                        {project.name}
                      </SelectOption>
                    ))}
                  </Select>
                );
              }}
            />
          </Col>
          <Col span={7}>
            <CreateNewProjectButton onClick={handleOpenModal} />
          </Col>
        </Row>
      </section>

      <ProjectEditorModal
        isVisible={showModal}
        project={{}}
        projects={projects}
        onHide={handleCloseModal}
        onSaveProject={handleAddNewProject}
      />
    </>
  );
};

export default ProjectField;
